import PositionJDPreview from '@components/position/preview';

const PositionJDPreviewPage = () => {
  return <PositionJDPreview />;
};

export default PositionJDPreviewPage;
